import Cpf from './cpf'
import Cnpj from './cnpj'

const rules = {
  cpf: Cpf,
  cnpj: Cnpj
}

export default rules



// WEBPACK FOOTER //
// ./src/rules/index.js